export enum AccountSearchType {
	Simple = 1,
	Detailed = 2,
}
